<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M16 8C16 12.4183 12.4183 16 8.00003 16C3.58175 16 3.05176e-05 12.4183 3.05176e-05 8C3.05176e-05 3.58172 3.58175 0 8.00003 0C12.4183 0 16 3.58172 16 8ZM9.00003 4C9.00003 4.55228 8.55231 5 8.00003 5C7.44775 5 7.00003 4.55228 7.00003 4C7.00003 3.44772 7.44775 3 8.00003 3C8.55231 3 9.00003 3.44772 9.00003 4ZM7.00003 7C6.44775 7 6.00003 7.44772 6.00003 8C6.00003 8.55229 6.44775 9 7.00003 9V12C7.00003 12.5523 7.44775 13 8.00003 13H9.00003C9.55231 13 10 12.5523 10 12C10 11.4477 9.55231 11 9.00003 11V8C9.00003 7.44772 8.55231 7 8.00003 7H7.00003Z" fill="#64748B"/>
  </svg>
</template>
<script>
export default {
  name: "Info"
}
</script>
